import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdSearchService } from 'src/app/shared/services/adsearch.service';
import { GeneralService } from 'src/app/shared/services/general.service';
import { AdUtils } from 'src/app/shared/utils/ad.utils';
import { ViewService } from '../view.service';

declare var $: any;

@Component({
  selector: 'app-ad-ground',
  templateUrl: './ad-ground.component.html',
  styleUrls: ['../ad-default.component.scss']
})
export class AdGroundComponent extends AdUtils implements OnInit {

  constructor(
    private route: ActivatedRoute,
    srs: AdSearchService,
    gs: GeneralService,
    vs: ViewService) {
    super(srs, gs, vs);

    if (this.route.snapshot.paramMap.get('id'))
      this.data = {
        friendlyTitle: this.route.snapshot.paramMap.get('id'),
        ad: this.route.snapshot.data['type']
      };
  }

  ngOnInit() {
    this.setDefault();
  }


  eventCallback(e) { }

  setDefault() {
    this.setDefaultUtils(true);
    this.loading = false;
  }


  unitSelected() {
    this._unitTypeSelected = {type:this.data.units[0], unit:{...this.data.units[0], title:this.data.title}};
    setTimeout(function () {
      $('#unitDetailProposal').modal({show:true});
    }, 100);
  }

}